export default __webpack_public_path__ + "sync-failed-icon.asset.d657c6591ab26ed8681dad462016a9ab.svg";